// extracted by mini-css-extract-plugin
export default {"actionSign":"adminActionStudents_actionSign__Lh+y+","features":"adminActionStudents_features__Db-Hd"};